export default function getUrlParam(parameter, localURL) {
  const urlParams = new URLSearchParams(localURL?.search ?? window.location.search);
  let urlparameter;
  if (urlParams.get(parameter)) {
    urlparameter = urlParams.get(parameter);
  }
  return urlparameter;
}

function getUrlParamRaw(parameter, defaultvalue, localURL) {
  // This function returns the raw value with encoded values supporting special characters.
  // For now it's only necessary with the search or with the or parameter.
  const urlParams = new URLSearchParams(localURL?.search ?? window.location.search);
  let urlparameter = defaultvalue;
  if ((localURL?.href ?? window.location.href).indexOf(parameter) > -1) {
    urlparameter = getUrlVars()[parameter];
  }

  let searchParameterFromSearchParams = urlParams.get(parameter);
  if (searchParameterFromSearchParams) {
    // Return the raw encoded substring so + only means space (application/x-www-form-urlencoded)
    // and decodeUrlQueryValue correctly handles literal plus (%2B) vs space (+)
    if (searchParameterFromSearchParams.includes('%')) {
      return urlparameter?.replace(/%(?![0-9a-fA-F]{2})/g, '%25');
    }
    if (searchParameterFromSearchParams.includes('&')) {
      return urlparameter?.replace(/&(?![0-9a-fA-F]{2})/g, '%26');
    }
    return urlparameter ?? searchParameterFromSearchParams;
  }
  return urlparameter;
}

function getUrlVars() {
  var vars = {};
  // eslint-disable-next-line
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value.split('#')[0];
  });
  return vars;
}

/**
 * Decodes a value from a URL query string (application/x-www-form-urlencoded).
 * Replaces + with space before decoding, since decodeURIComponent does not handle +.
 * Use when decoding values from getUrlParamRaw or raw query strings.
 */
function decodeUrlQueryValue(value) {
  if (value === undefined || value === null) return value;
  return decodeURIComponent(String(value).replace(/\+/g, '%20'));
}

export { getUrlParamRaw, decodeUrlQueryValue };
